// components/Sidebar.js
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons"
import classNames from "classnames"


import logo from "../../../assets/fribl-LOGO-white-aug23.svg"
import {
  GeneralSettingsSidebar,
} from "./components"

const Sidebar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  return (
    <div className="sidebar">
      <div className="sidebar__imagecontainer">
        <Link to={"/job-match/select-cv"}>
          <img src={logo} alt="logo" className="sidebar__logo" />
        </Link>

        {/* Hamburger */}
        <div
          className="sidebar__toggle"
          role={"button"}
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <FontAwesomeIcon icon={faBars} color="white" size={"2x"} />
        </div>
      </div>

      <div className="sidebar__content">
        <GeneralSettingsSidebar back={() => {}} />
      </div>

      <div
        className={classNames("sidebar__backdrop", {
          "sidebar__backdrop--visible": showMobileMenu,
        })}
        onClick={() => setShowMobileMenu(false)}
      />

      <div
        onClick={() => setShowMobileMenu(false)}
        className={classNames("sidebar__content-mobile", {
          "sidebar__content-mobile--visible": showMobileMenu,
        })}
      >
        <div className="sidebar__mobile-header">
          <Link to={"/"}>
            <img src={logo} className="sidebar__logo" alt="logo" />
          </Link>

          <div
            className="sidebar__toggle"
            role={"button"}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            <FontAwesomeIcon icon={faClose} color="white" size={"2x"} />
          </div>
        </div>

        <GeneralSettingsSidebar back={() => {}} />
      </div>
    </div>
  )
}

export default Sidebar;
